import { MenuOutlined } from '@ant-design/icons';

import React, { useEffect, useState } from 'react';
import { Select, Space } from 'antd';

import oneshiftByCarousellLogo from '_images/oneshift-by-carousell-logo.png';
import carousellAutosLogo from '_images/carousell-autos-logo.png';
import phoneIcon from '_images/phone-icon-white.svg';
import whatsappIcon from '_images/whatsapp-icon-outline.svg';

import HeaderMenu from './HeaderMenu';
import MenuSlideout from './MenuSlideout';

import { AnchorLink } from "gatsby-plugin-anchor-links";

import { graphql, useStaticQuery } from 'gatsby';

export default function Header({ hideTicker }) {
  const [visible, setVisible] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  useEffect(() => {
    if (visible) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }, [visible]);

  const [isCarousellAutos, setIsCarousellAutos] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const source = params.get("utm_source");
    const crsSources = ["crs-organic", "crs-intads", "crs-social"]
    if (source && crsSources.includes(source)) {
      setIsCarousellAutos(true);
    }
  }, []);

  const { allSanityHomepageSettings } = useStaticQuery(graphql`
      query HeaderQuery {
        allSanityHomepageSettings {
          edges {
            node {
              topTickerText
              topTickerURL
            }
          }
        }
      }
    `);

  const homepageSettings = allSanityHomepageSettings.edges.map((d) => {
    return d.node;
  })[0];

  return (
    <header className="border-b border-stroke-boundary fixed left-0 right-0 z-50 top-0 bg-white">
      {!hideTicker &&
        <div className="h-12 px-4 sm:h-8 flex mx-auto items-center justify-center bg-[#932492] align-middle shadow-lg text-xs sm:text-sm">
          <a href={homepageSettings.topTickerURL} className="text-white hover:text-white text-md text-center">{homepageSettings.topTickerText}</a>
        </div>
      }
      <div className="h-[68px] max-w-[1440px] mx-auto flex justify-between items-center gap-x-4 select-none px-4 sm:px-8 xl:px-16">
        <div className="flex items-center gap-x-8">
          <div className="flex items-center gap-x-2 flex-shrink-0">
            <div className="block md:hidden">
              <MenuOutlined
                style={{ fontSize: 20 }}
                onClick={() => setVisible(true)}
              />
            </div>
            <a className="flex-shrink-0" href="/">
              {isCarousellAutos
                ? <img
                  src={carousellAutosLogo}
                  className="h-[24px] md:w-[208px] md:h-[40px]"
                  alt="Carousell Autos Logo"
                />
                : <img
                  src={oneshiftByCarousellLogo}
                  className="w-[69px] h-[24px] md:w-[115px] md:h-[40px]"
                  alt="OneShift Logo"
                />
              }
            </a>
          </div>
          <div className="hidden md:flex">
            <HeaderMenu />
          </div>
        </div>
        <div className="flex items-center gap-x-4">
          <div className="md:hidden">
            <div className="flex items-center gap-x-4">
              <div
                className="text-sm font-semibold"
                onClick={() => {
                  setVisible(true);
                  setOpenMenu('Sell');
                }}
                aria-hidden="true"
              >
                Sell
              </div>
              <div
                className="text-sm font-semibold"
                onClick={() => {
                  setVisible(true);
                  setOpenMenu('Buy');
                }}
                aria-hidden="true"
              >
                Buy
              </div>
              <div
                className="text-sm font-semibold"
                onClick={() => {
                  setVisible(true);
                  setOpenMenu('Articles');
                }}
                aria-hidden="true"
              >
                Articles
              </div>
            </div>
          </div>
          {/* <div className="w-40">
            <Space
                style={{
                  width: '100%',
                }}
                direction="vertical"
              >
              <Select
                showSearch
                placeholder="Search make..."
                options={[
                  { value: 'BMW', label: 'BMW' },
                  { value: 'Toyota', label: 'Toyota' },
                  { value: 'Volkswagen', label: 'Volkswagen' },
                  { value: 'Mercedes-Benz', label: 'Mercedes-Benz' },
                ]}
                size="large"
                style={{
                  width: '100%',
                }}
                allowClear
              />
            </Space>
          </div> */}
          <a
            className="hidden py-2 px-4 flex items-center gap-x-2 border rounded hover:bg-gray-50"
            href="https://wa.me/65335878"
            target="_blank"
            rel="noreferrer"
          >
            <img src={whatsappIcon} alt="Whatsapp" className="w-4 h-4" />
            <span className="text-base font-semibold leading-6 text-os-black hidden lg:inline">
              Message Us
            </span>
          </a>
          <a
            className="py-2 px-4 flex items-center gap-x-2 rounded bg-caroured50 hover:opacity-80"
            href="tel:65335878"
          >
            <img src={phoneIcon} alt="Phone" className="size-4" />
            <span className="text-base font-semibold leading-6 text-white hidden lg:inline">
              6533 5878
            </span>
          </a>
        </div>
        <MenuSlideout
          openMenu={openMenu}
          show={visible}
          onClose={() => {
            setVisible(false);
            setOpenMenu(null);
          }}
        />
      </div>
    </header>
  );
}
